import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';

export class GetDriversLastPlacesCommand extends IRequestCommand<
  IGetDriversLastPlacesResponse[],
  ErrorDetails,
  IGetDriversLastPlacesParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/lastPlace?state=';

  public override setParameters(parameters: IGetDriversLastPlacesParameters) {
    this._commandUrl = this._commandUrl.replace('{carrierUserId}', parameters.carrierUserId);
  }
}

export interface IGetDriversLastPlacesParameters extends ICommandParameters {
  carrierUserId: string;
}

export interface IGetDriversLastPlacesResponse extends ICommandResponse {
  driverUserId: number;
  firstName: string;
  lastName: string;
  lastPlace: {
    id: number;
    latitude: string;
    longitude: string;
    shortName: string;
  };
  driverState: string;
  lastSee: string;
}
